// extracted by mini-css-extract-plugin
module.exports = {"game-container":"game-container_game-container__Eshg7"};